import { LayoutManager } from './layouts/LayoutManager.js'
import { categories, menuItems } from '../data/menuData.js'

export class MenuView {
  constructor(config = null, menuData = null, i18n = null) {
    this.config = config || this.getDefaultConfig();
    this.menuData = menuData || this.getDefaultMenuData();
    this.cartCount = 0;
    this.i18n = i18n;
    
    // Initialize layout manager with configuration
    this.layoutManager = new LayoutManager(this.config, this.menuData, this.i18n);
  }

  getDefaultConfig() {
    return {
      name: 'Restaurant',
      branding: {
        primaryColor: getComputedStyle(document.documentElement).getPropertyValue('--color-primary'),
        secondaryColor: getComputedStyle(document.documentElement).getPropertyValue('--color-secondary')
      },
      settings: {
        currency: 'PLN'
      }
    };
  }

  getDefaultMenuData() {
    return {
      categories: categories,
      items: menuItems,
      specials: []
    };
  }

  render() {
    return this.layoutManager.render();
  }

  bindEvents() {
    this.layoutManager.bindEvents();
  }

  updateCartCount(count) {
    this.cartCount = count;
    this.layoutManager.updateCartCount(count);
  }

  show() {
    this.layoutManager.show();
  }

  hide() {
    return this.layoutManager.hide();
  }
}